export default "__VITE_ASSET__BTFUkhff__"